import { render, staticRenderFns } from "./squareAccount.vue?vue&type=template&id=25105d08&scoped=true"
import script from "./squareAccount.vue?vue&type=script&lang=js"
export * from "./squareAccount.vue?vue&type=script&lang=js"
import style0 from "./squareAccount.vue?vue&type=style&index=0&id=25105d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25105d08",
  null
  
)

export default component.exports